import React, { useEffect, useRef } from 'react'
import { gsap, Power1 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import styles from 'components/mvv/Mvv/Brand.module.scss'

gsap.registerPlugin(ScrollTrigger)

const OurVision: React.FC = () => {
  const sectionRef = useRef<HTMLElement | null>(null)

  useEffect(() => {
    if (sectionRef.current) {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: sectionRef.current,
          start: 'top 80%',
          toggleActions: 'play none none reverse',
        },
      })

      tl.from(
        sectionRef.current.querySelectorAll(
          `.${styles.section_top}, .${styles.section_body}, .${styles.section_body_ttl}, .${styles.section_body_desc}`,
        ),
        {
          y: 50,
          duration: 0.5,
          opacity: 0,
          ease: Power1.easeOut,
          stagger: 0.2,
        },
      )
    }

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill())
    }
  }, [])

  return (
    <section className={styles.section} ref={sectionRef}>
      <div className={styles.inner}>
        <div className={styles.section_top}>
          <span className={styles.section_top_icon}></span>
          <h2 className={styles.section_top_ttl}>
            <span className={styles.section_top_ttl_en}>Our vision</span>
            <span className={styles.section_top_ttl_ja}>到達点</span>
          </h2>
        </div>
        <div className={styles.section_body}>
          <h3 className={styles.section_body_ttl}>
            <span className={styles.section_body_ttl_ja}>
              日本の IT を再起動する
              <br /> “最高のチーム”になる
            </span>
            <span className={styles.section_body_ttl_en}>We're the team to reboot Japan's IT industry</span>
          </h3>
          <p className={styles.section_body_desc}>
            私たちは日々のプロジェクトで日本のITに新たな標準を示し、3年後には「Aitriaのやり方が再起動後の当たり前」と呼ばれる世界を創ります。全国の精鋭達が”Be
            modern, Be standard”という価値観のもと”One for all, All for
            One”で結束し、AIを呼吸するように操る――その集合体が“最高のチーム”になることが、我々のビジョンです。
          </p>
        </div>
      </div>
    </section>
  )
}

export default OurVision
